// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vision_main_section__JZ9NO {
  max-width: 100%;
  margin: 4rem 0 2rem;

  .vision_top_section__ObJ6O {
    width: 90%;
  }

  & h6 {
    color: #242020;
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & span {
    color: #62677a;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }

  & p {
    color: #242020;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

.vision_container__xwsoa {
  display: flex;
  align-items: flex-start;
}

/* .left {
  flex: 1;
  padding: 10px;
} */

.vision_right__YKEvq {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
}

.vision_left__2iwS3 img{
  max-width: 98%;
  height: auto;

}
.vision_right__YKEvq img {
  max-width: 100%;
  height: auto;
  margin-bottom: 10px;
}

@media screen and (max-width: 568px) {
  .vision_main_section__JZ9NO {
    margin: 2rem 0;

    .vision_top_section__ObJ6O {
      width: 100%;
    }
  }

  .vision_right__YKEvq {
    padding: 0 4px;
  }

  .vision_right__YKEvq img {
    max-width: 100%;
    height: auto;
    margin-bottom: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Vision/vision.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;;EAEnB;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;;AAEd;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;;IAEd;MACE,WAAW;IACb;EACF;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".main_section {\n  max-width: 100%;\n  margin: 4rem 0 2rem;\n\n  .top_section {\n    width: 90%;\n  }\n\n  & h6 {\n    color: #242020;\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & span {\n    color: #62677a;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n\n  & p {\n    color: #242020;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n}\n\n.container {\n  display: flex;\n  align-items: flex-start;\n}\n\n/* .left {\n  flex: 1;\n  padding: 10px;\n} */\n\n.right {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 0;\n}\n\n.left img{\n  max-width: 98%;\n  height: auto;\n\n}\n.right img {\n  max-width: 100%;\n  height: auto;\n  margin-bottom: 10px;\n}\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    margin: 2rem 0;\n\n    .top_section {\n      width: 100%;\n    }\n  }\n\n  .right {\n    padding: 0 4px;\n  }\n\n  .right img {\n    max-width: 100%;\n    height: auto;\n    margin-bottom: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `vision_main_section__JZ9NO`,
	"top_section": `vision_top_section__ObJ6O`,
	"container": `vision_container__xwsoa`,
	"right": `vision_right__YKEvq`,
	"left": `vision_left__2iwS3`
};
export default ___CSS_LOADER_EXPORT___;
